import { Link } from "react-router-dom"
import { useOrganization } from "../../OrganizationContext"
import { useUser } from "../../UserContext"
import { Button } from "../ui"

export default function MarketingCta({
  children = "Start seven-day free trial",
  authenticatedLabel = "Open app",
  ...props
}) {
  const user = useUser()
  const { organizations = [] } = useOrganization()
  const destination = user
    ? organizations.length > 0
      ? "/dashboard"
      : "/welcome"
    : "/login"

  return (
    <Button as={Link} to={destination} {...props}>
      {user ? authenticatedLabel : children}
    </Button>
  )
}

